export default "__VITE_ASSET__C1pwCWpL__"